export const firebaseConfig = {
    apiKey: "AIzaSyARLLYI4NQ81LrU4wcdGFDc6823xW2V4R0",
    authDomain: "ta-nasci.firebaseapp.com",
    projectId: "ta-nasci",
    storageBucket: "ta-nasci.appspot.com",
    messagingSenderId: "712983381089",
    appId: "1:712983381089:web:20e104b38f8ac29fa01620",
    measurementId: "G-4TQCHMR5HB"
};